export default __webpack_public_path__ + "static/media/payment error.1bb0a26c.svg";